<template>
  <v-container>
    <h1 class="display-1 pt-3">Course Builder</h1>
    <v-row align="center">
      <v-col cols="12">
        <v-card flat outlined>
          <v-app-bar color="white" dense flat>
            <v-text-field
              background-color="white"
              hide-details
              flat
              solo
              color="blue"
              prepend-inner-icon="mdi-magnify"
              label="Search course name"
              v-model="search"
            ></v-text-field>
            <!-- <v-btn
              depressed=""
              color="blue"
              @click="showCreateCourse = !showCreateCourse"
              v-show="permissions.includes('writer')"
              class="white--text ml-2 mt-auto mb-auto"
              >Create Course</v-btn
            > -->
          </v-app-bar>
        </v-card>
      </v-col>
    </v-row>
    <!-- Drafts -->
    <a-l-draft
      v-if="permissions.includes('writer')"
      :key="courses.draft_refresh + 'draft'"
      :search="search"
      @updatefull="
        courses.pending_refresh = courses.pending_refresh + 1;
        courses.draft_refresh = courses.draft_refresh + 1;
      "
      @update="courses.pending_refresh = courses.pending_refresh + 1"
    >
      <template slot="pre-drafts" v-show="permissions.includes('writer')">
        <v-col
          class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 hidden-sm-and-down"
        >
          <v-container class="ma-0 pa-0" style="height:100%">
            <div
              class="dashed-outline"
              @click="showCreateCourse = !showCreateCourse"
            >
              <v-container fluid style="height:100%">
                <v-row style="height:100%">
                  <v-col cols="12" style="height:100%">
                    <v-row align="center" justify="center" style="height:100%">
                      <p class="pa-0 ma-0 pb-1">
                        <v-btn
                          depressed=""
                          x-small=""
                          bottom
                          color="blue"
                          dark
                          fab
                          class="mr-3"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </p>
                      <p class="title pa-0 ma-0 pb-1">Create New Course</p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-container>
        </v-col>
      </template>
      <template slot="missing"
        ><span
          class="blue--text fake-hover"
          @click="showCreateCourse = !showCreateCourse"
          >Create</span
        >
        a new draft to get started.
      </template>
    </a-l-draft>
    <!-- End Drafts -->
    <!-- Pending Courses -->
    <a-l-pending
      v-if="permissions.includes('publisher')"
      :key="courses.pending_refresh + 'pending'"
      :search="search"
      @update="
        courses.draft_refresh++;
        courses.publish_refresh++;
      "
    />
    <!--  -->
    <a-l-published
      :search="search"
      :key="courses.publish_refresh + 'published'"
      v-if="permissions.includes('publisher')"
      @update="
        courses.draft_refresh++;
        courses.publish_refresh++;
      "
    />
    <v-btn
      bottom
      color="blue darken-2"
      dark
      fab
      fixed
      right
      @click="showCreateCourse = !showCreateCourse"
      v-show="permissions.includes('writer')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <a-l-createcoursemodal
      :dialog="showCreateCourse"
      @cancel="showCreateCourse = false"
      @finish="createCourse"
      v-show="permissions.includes('writer')"
    />
  </v-container>
</template>
<style scoped>
.dashed-outline {
  border-style: dashed !important;
  border-color: rgb(108, 109, 121);
  border-radius: 4px;
  margin-top: 3px;
  border-width: 2px;
  width: 99.8%;
  height: 192px;
}
.dashed-outline:hover {
  border-color: #24a3d1;
  background-color: #24a3d136;
  cursor: pointer;
}
.filter_menu {
  overflow-x: hidden;
  overflow-y: hidden;
}
.fake-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
<script>
import draftCards from "./components/drafts";
import pendingCards from "./components/pending";
import publishedCards from "./components/published";

import createCourseModal from "./components/createcoursemodal";
import services from "@/services/index.js";

export default {
  components: {
    "a-l-draft": draftCards,
    "a-l-pending": pendingCards,
    "a-l-createcoursemodal": createCourseModal,
    "a-l-published": publishedCards
  },
  data: () => ({
    __initialized__: false,
    expand: false,
    showCreateCourse: false,
    showfilters: false,
    search: "",
    fav: true,
    menu: false,
    message: false,
    hints: true,
    loader: null,
    courses: {
      drafts: [],
      draft_refresh: 0,
      pending: [],
      pending_refresh: 0,
      published: []
    }
  }),
  methods: {
    /**
     * @param {String} title Title to be filtering by
     */
    filterCourses(title, source) {
      return source.filter(course =>
        String(course.name)
          .trim()
          .toLowerCase()
          .includes(
            String(title)
              .trim()
              .toLowerCase()
          )
      );
    },
    async createCourse(object) {
      this.showCreateCourse = false;
      try {
        console.log("Create course got", object);
        this.$store.commit("setLoading", true);
        const { name, category, duration } = object;
        console.log(name, category, duration);
        await services.course.create({
          coursedoc: {
            name: name,
            category: category,
            duration: 1
          },
          type: "writer"
        });
        try {
          window.analytics.track("Course Created");
          this.$ga.event({
            eventCategory: "dashboard-courses",
            eventAction: "create-draft",
            eventLabel: "Dashboard"
          });
        } catch (err) {
          console.log(err);
        }
        this.$store.commit("setLoading", false);
        this.courses.draft_refresh = this.courses.draft_refresh + 1;
        this.onStartup();
      } catch (err) {
        this.$store.commit("setLoading", false);
      }
    }
    // async onStartup() {
    //   this.$store.commit("setLoading", true);
    //   this.courses.drafts = await services.draft.get({ type: "notpublished" });
    //   this.$store.commit("setLoading", false);
    //   this.__initialized__ = true;
    // }
  },
  computed: {
    permissions() {
      if (Array.isArray(this.$store.getters.getUser.permissions)) {
        return this.$store.getters.getUser.permissions;
      } else {
        return [];
      }
    }
  },
  mounted() {
    // this.__initialized__ = false;
    // this.onStartup();
  }
};
</script>
